import { useEffect, useState } from "react";
import { msalInstance } from "./utils/auth/Auth-utils";
import { useAuth } from "./context/AuthContext";
import { STORAGE_NAME_ACCESS_TOKEN } from "./utils/constantes";

export const AccessUser = ({ children }) => {

    const { isLoading: isLoadingConfigMsal } = useAuth();
    const [isLoadingAuth, setIsLoadingAuth] = useState(false);

    useEffect(() => {
        let isMounted = true;

        if (!isLoadingConfigMsal) 
            msalInstance?.handleRedirectPromise().then((response) => {
                if (response) localStorage.setItem(STORAGE_NAME_ACCESS_TOKEN, response.accessToken);
                if (isMounted) setIsLoadingAuth(true);

            });

        return () => {
            isMounted = false;
        };
    }, [isLoadingConfigMsal])

    return (
        <div className="wrapper-route">
            {isLoadingAuth && children}
        </div>
    );
};

export default AccessUser;